import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Select,
  SelectChangeEvent,
  Switch,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useGetVehicleTypes from '../../apiHooks/useGetVehicleTypesApi';
import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import { showError, showToast } from '../../constants/toasts';
import MainContainer from '../../layout/MainContainer';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import {
  useLazyDeleteBodyTypeQuery,
  useLazyGetBodyTypeQuery,
  useUpdateBodyTypeMutation,
} from '../../service/bodyType';
import { BodyTypeData, CommonBody } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { isValidInput } from '../../utils/validations';

const BodyType = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [rows, setRows] = useState<BodyTypeData[]>([]);
  const [count, setCount] = useState(0);
  const [selectedId, setSelectedId] = useState<string>('');
  const [openDelete, setOpenDelete] = useState(false);
  const [vehicleType, setVehicleType] = useState<any>('default');

  const [getData] = useLazyGetBodyTypeQuery();
  const [deleteBodyType] = useLazyDeleteBodyTypeQuery();
  const [updateBodyType] = useUpdateBodyTypeMutation();
  const { data } = useGetVehicleTypes();

  const handleVehicleType = (event: SelectChangeEvent) => {
    setVehicleType(event.target.value as any);
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const open1 = Boolean(anchorEl1);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>, rowId: string) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const getList = async () => {
    setLoading(true);
    try {
      const response = await getData({
        page: page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        vehicleId: vehicleType !== 'default' ? vehicleType : '',
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setRows(response?.data?.data || []);
        setCount(response?.data?.count);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteBodyType({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        showToast('Deleted successfully');
        getList();
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };
  const handleStatusUpdate = async (id: string, status: any) => {
    const body = {
      isBlocked: status,
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateBodyType({
        body: encryptedBody,
        id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        const updatedData = rows?.map((item) => {
          if (item?._id === id) {
            return {
              ...item,
              isBlocked: status,
            };
          }
          return item;
        });
        setRows(updatedData);
        if (status === true) {
          showToast('Body type blocked successfully');
        } else {
          showToast('Body type unblocked successfully');
        }
      } else {
        showError('Please try again');
      }
    } catch (error: any) {
      console.error(error, 'errror');
      showError(error?.data?.message || '');
    }
  };

  useEffect(() => {
    getList();
  }, [debouncedSearchTerm, page, vehicleType]);

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: 'image',
      headerName: 'Image',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={row?.image} alt="" />
            </figure>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: 'name',
      headerName: 'Title',
      editable: false,
      sortable: false,
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: 'vehicleType',
      headerName: 'Vehicle Type',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.vehicle?.name || ''}</p>
          </div>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'status',
      filterable: false,
      sortable: false,
      headerName: 'Block/Unblock',
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.isBlocked}
            onChange={() => handleStatusUpdate(row?._id, !row?.isBlocked)}
          />
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(event) => handleClick1(event, row?._id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => {
                    navigate(`edit/${selectedId}`);
                    handleClose1();
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorEl1(null);
                    setOpenDelete(true);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1> Body Types</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Vehicle Specifications -
            Body Types
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate('add')}>
            Add Body Type
          </Button>
        </div>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm('')}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <div className="control_group w_100">
                <Select
                  sx={{ minWidth: '150px' }}
                  fullWidth
                  labelId="vehicleType"
                  id="vehicleType"
                  value={vehicleType}
                  onChange={handleVehicleType}
                >
                  <MenuItem disabled value="default">
                    Select Vehicle Type
                  </MenuItem>
                  {data?.length
                    ? data?.map((item, i: number) => {
                        return (
                          <MenuItem value={item?._id} key={i}>
                            {item?.name || '-'}
                          </MenuItem>
                        );
                      })
                    : null}
                </Select>
              </div>
              {vehicleType === 'default' || vehicleType === '' ? null : (
                <Button
                  sx={{ minWidth: '120px' }}
                  className="btn btn_orange"
                  onClick={() => setVehicleType('default')}
                >
                  Clear Filter
                </Button>
              )}
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={rows}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </div>
        </Box>
        <ConfirmationModal
          text="Are you sure to delete this body type?"
          openModal={openDelete}
          setOpenModal={setOpenDelete}
          handleSubmit={handleDelete}
        />
      </div>
    </MainContainer>
  );
};

export default BodyType;
